import React, { FC } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Plus } from '@styled-icons/bootstrap';
import SparkImage from 'assets/img/spark.png';
import { CardContainer, CardIllustration, ThemeButton } from 'DesignSystem';
import TableSkeleton from 'DesignSystem/DataDisplay/TableSkeleton/TableSkeleton';
import { EBackgroundTypes, EIllustrationTypes } from 'DesignSystem/types/background.types';
import { EAvailableSizes } from 'DesignSystem/types/size.types';

interface IDataImportOverviewCardProps {
  title: string;
  onAddTableClick: () => void;
}

const Spark = styled('img')(() => ({
  position: 'absolute',
  width: 60,
  height: 60,
  right: -32,
  top: -27,
}));

const DataImportOverviewCard: FC<IDataImportOverviewCardProps> = ({ title, onAddTableClick }) => {
  // Do not pass the mouse event
  const handleAddTableClick = () => onAddTableClick();

  return (
    <CardContainer
      title={title}
      size={EAvailableSizes.LARGE}
      background={EBackgroundTypes.WORLD}
      loading={false}
      renderIllustration={
        <CardIllustration image={EIllustrationTypes.LOCATIONS} width={260} right={0} top={0} />
      }
    >
      <Box pb={2} mt="auto" position="relative" maxWidth="550px">
        <TableSkeleton maxWidth="550px" />
        <Spark src={SparkImage} />
      </Box>
      <ThemeButton
        onClick={handleAddTableClick}
        startIcon={<Plus size={20} color="white" />}
        size="large"
      >
        Add new data set
      </ThemeButton>
    </CardContainer>
  );
};

export default DataImportOverviewCard;
